(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-editorial-article]');

  roots.forEach(function (root) {
    var body = root.querySelector('[data-editorial-body]');
    var tocContainers = root.querySelectorAll('[data-editorial-toc]');
    var headings = body ? Array.prototype.slice.call(body.querySelectorAll('h2, h3')) : [];

    if (headings.length >= 2 && tocContainers.length) {
      var usedIds = {};

      headings.forEach(function (heading, index) {
        var baseId = heading.id || heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');

        if (!baseId) baseId = 'section-' + (index + 1);

        var uniqueId = baseId;
        var suffix = 2;
        while (usedIds[uniqueId] || document.getElementById(uniqueId)) {
          uniqueId = baseId + '-' + suffix;
          suffix += 1;
        }

        if (!heading.id) heading.id = uniqueId;
        usedIds[heading.id] = true;
      });

      tocContainers.forEach(function (container) {
        var list = container.querySelector('[data-editorial-toc-list]');
        if (!list) return;

        headings.forEach(function (heading) {
          var item = document.createElement('li');
          var link = document.createElement('a');

          item.className = 'editorial-article__toc-item editorial-article__toc-item--' + heading.tagName.toLowerCase();
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          item.appendChild(link);
          list.appendChild(item);
        });

        container.hidden = false;
      });

      if ('IntersectionObserver' in window) {
        var tocLinks = root.querySelectorAll('[data-editorial-toc] a');
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            tocLinks.forEach(function (link) {
              if (link.getAttribute('href') === '#' + entry.target.id) {
                link.setAttribute('aria-current', 'location');
              } else {
                link.removeAttribute('aria-current');
              }
            });
          });
        }, {
          rootMargin: '-18% 0px -70% 0px',
          threshold: 0
        });

        headings.forEach(function (heading) {
          observer.observe(heading);
        });
      }
    }

    var shareButtons = root.querySelectorAll('[data-editorial-share]');
    shareButtons.forEach(function (button) {
      button.addEventListener('click', async function () {
        var title = button.getAttribute('data-title') || document.title;
        var url = button.getAttribute('data-url') || window.location.href;
        var status = root.querySelector('[data-editorial-share-status]');

        try {
          if (navigator.share) {
            await navigator.share({ title: title, url: url });
            if (status) status.textContent = 'Share options opened.';
          } else if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(url);
            if (status) status.textContent = 'Link copied.';
          } else {
            var textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.setAttribute('readonly', '');
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            if (status) status.textContent = 'Link copied.';
          }
        } catch (error) {
          if (error && error.name !== 'AbortError' && status) {
            status.textContent = 'Sharing was unavailable. Copy the page address from your browser.';
          }
        }
      });
    });
  });
})();
